// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3WFL2","label":"Radio_label__1o0v6","checkMark":"Radio_checkMark__HAguH","disabled":"Radio_disabled__2edJr"};